import { useState } from "react";
import { Icons } from "./icons";
import { copyEphemeral } from "./clipboard";

// Shown once after creating a vault: the org recovery private key (§17.1). Never stored on the
// server; the owner must save it offline (break-glass envelope / HSM).
export function RecoveryKeyModal({ recoveryKey, onClose }: { recoveryKey: string; onClose: () => void }) {
  const [saved, setSaved] = useState(false);
  const download = () => {
    const blob = new Blob([recoveryKey], { type: "text/plain" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "vault-recovery-key.txt";
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
  };
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/60">
      <div className="w-[480px] rounded-md border border-border bg-panel shadow-xl">
        <div className="flex items-center gap-2 border-b border-border px-5 py-4 font-semibold"><Icons.key className="h-4 w-4 text-warn" /> Recovery key — shown once</div>
        <div className="flex flex-col gap-3 px-5 py-5 text-sm">
          <div className="rounded bg-danger/15 px-3 py-2 text-xs text-danger">
            ⚠ This is the org recovery key. It is shown only now and is <b>never stored on the server</b>.
            Save it offline (break-glass envelope / HSM). Without it, recovery is impossible.
          </div>
          <textarea readOnly value={recoveryKey} className="h-24 w-full resize-none rounded border border-border bg-panel2 px-2 py-1 font-mono text-[11px]" />
          <div className="flex gap-2">
            <button onClick={() => copyEphemeral(recoveryKey)} className="rounded border border-border px-3 py-1.5 text-xs hover:border-accent">Copy</button>
            <button onClick={download} className="rounded border border-border px-3 py-1.5 text-xs hover:border-accent">Download .txt</button>
          </div>
          <label className="flex items-center gap-2 text-xs">
            <input type="checkbox" checked={saved} onChange={(e) => setSaved(e.target.checked)} />
            I have stored this recovery key offline.
          </label>
          <div className="flex justify-end">
            <button onClick={onClose} disabled={!saved} className="rounded bg-accent px-3 py-1.5 text-white hover:bg-accent2 disabled:opacity-60">Done</button>
          </div>
        </div>
      </div>
    </div>
  );
}
